import React from "react";
import {
  FaDownload,
  FaComment,
  FaUser,
  FaEnvelope,
  FaMapMarkerAlt,
  FaBriefcase,
} from "react-icons/fa";

const About = () => {
  return (
    <section className="about section-padding" id="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            About <span>Me</span>
          </h2>
          <p className="section-subtitle">Get to know me better</p>
          <div className="section-line"></div>
        </div>
        <div className="about-content">
          <div className="about-image">
            <div className="image-frame">
              <img
                src="https://cdn.dribbble.com/userupload/46129235/file/76479340ed06106da9868755d3f82fcd.jpg?resize=1200x1209&vertical=center"
                alt="Working on code"
                className="about-img"
              />
              <div className="experience-badge">
                <span>2+ Years</span>
                <p>Experience</p>
              </div>
            </div>
          </div>
          <div className="about-text">
            <h3>
              Turning Ideas Into <span>Digital Reality</span>
            </h3>
            <p>
              I'm Nirmal Dhakal, a passionate Full Stack Developer based in
              Nepal. I specialize in creating modern web applications with clean
              code and user-centric design.
            </p>
            <p>
              With expertise in both frontend and backend technologies, I build
              scalable solutions that deliver exceptional user experiences.
            </p>

            <div className="about-info">
              <div className="info-item">
                <strong>
                  <FaUser /> Name:
                </strong>
                <span>Nirmal Dhakal</span>
              </div>
              <div className="info-item">
                <strong>
                  <FaEnvelope /> Email:
                </strong>
                <span>nirmalbsccsit2@gmail.com</span>
              </div>
              <div className="info-item">
                <strong>
                  <FaMapMarkerAlt /> Location:
                </strong>
                <span>Palpa, Nepal</span>
              </div>
              <div className="info-item">
                <strong>
                  <FaBriefcase /> Freelance:
                </strong>
                <span className="available">Available</span>
              </div>
            </div>

            <div className="about-buttons">
              <a
                href="/images/nirmalDhakal.pdf"
                className="btn btn-primary"
                download
              >
                <FaDownload /> Download CV
              </a>
              <a href="#contact" className="btn btn-secondary">
                <FaComment /> Let's Talk
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
